import React from 'react';

interface CustomTooltipProps {
  active?: boolean;
  payload?: any[];
  label?: string;
  config?: any;
  xAxisLabel?: string;
  showPercentage?: boolean;
  currencyFormat?: boolean;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ 
  active, 
  payload, 
  label, 
  config, 
  xAxisLabel = 'Category',
  showPercentage = false,
  currencyFormat = false
}) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  return (
    <div style={{ 
      backgroundColor: 'rgba(0, 0, 0, 0.8)', 
      color: 'white',
      padding: '8px 12px', 
      borderRadius: '6px',
      fontSize: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
      border: '1px solid rgba(255,255,255,0.2)',
      maxWidth: '200px',
      zIndex: 1000
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '4px', color: '#f0f0f0' }}>
        {`${xAxisLabel}: ${label}`}
      </div>
      {payload.map((entry: any, index: number) => {
        if (!entry.value || entry.value === 0) return null;
        
        const isCurrency = currencyFormat || 
          (config?.yAxis?.primary?.format === 'currency') ||
          (config?.yAxis?.format === 'currency');
        
        const formattedValue = isCurrency 
          ? `$${entry.value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
          : entry.value.toLocaleString();
        
        return (
          <div key={index} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            margin: '2px 0',
            fontSize: '11px'
          }}>
            <div style={{ 
              width: '8px', 
              height: '8px', 
              backgroundColor: entry.color, 
              marginRight: '6px',
              borderRadius: '2px'
            }} />
            <span style={{ flex: 1 }}>{entry.name}:</span>
            <span style={{ fontWeight: 'bold', marginLeft: '4px' }}>{formattedValue}</span>
            {showPercentage && entry.payload && entry.payload.percentage && (
              <span style={{ marginLeft: '4px', color: '#ccc' }}>
                ({entry.payload.percentage.toFixed(1)}%)
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CustomTooltip;
